"use strict";
/**
 * AlignmentGraph Component
 *
 * Renders the extended React Flow graph showing:
 * Strategy Columns -> Metrics Column -> Use Case Column
 *
 * This visualization helps understand how a strategy connects
 * to specific AI use cases through business metrics.
 *
 * This component owns the dashboard alignment graph rendering
 * and keeps the dashboard feature independent from Admin-only
 * feature folders.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlignmentGraph = void 0;
var react_1 = __importDefault(require("react"));
var StrategyReactFlow_1 = require("../../shared/StrategyReactFlow");
var components_1 = require("../../shared/components");
var constants_1 = require("../../shared/constants");
require("../styles/alignment-graph.scss");
/**
 * AlignmentGraph - Extended graph visualization
 */
var AlignmentGraphComponent = function (_a) {
    var _b;
    var alignmentData = _a.alignmentData, isLoading = _a.isLoading;
    var structure = (_b = alignmentData === null || alignmentData === void 0 ? void 0 : alignmentData.structure) !== null && _b !== void 0 ? _b : [];
    if (isLoading || !alignmentData) {
        return react_1.default.createElement(components_1.SkeletonGraph, { height: constants_1.DEFAULT_GRAPH_HEIGHT });
    }
    return react_1.default.createElement(StrategyReactFlow_1.StrategyReactFlow, { columns: structure, isLoading: false });
};
var AlignmentGraph = react_1.default.memo(AlignmentGraphComponent);
exports.AlignmentGraph = AlignmentGraph;
AlignmentGraph.displayName = "AlignmentGraph";
